// @mui
import { SvgIcon } from "@mui/material";

function CircleClockFillIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "transparent",
        "& path": {
          stroke: (theme) => theme.palette.common.white,
        },
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.49 14.956C15.349 15.191 15.1 15.321 14.845 15.321C14.715 15.321 14.582 15.287 14.462 15.214L11.287 13.314C11.06 13.179 10.922 12.934 10.922 12.67V8.581C10.922 8.166 11.258 7.831 11.672 7.831C12.086 7.831 12.422 8.166 12.422 8.581V12.245L15.231 13.927C15.587 14.14 15.703 14.601 15.49 14.956ZM12 2.5C6.761 2.5 2.5 6.762 2.5 12C2.5 17.239 6.761 21.5 12 21.5C17.238 21.5 21.5 17.239 21.5 12C21.5 6.762 17.238 2.5 12 2.5Z"
        fill="#000000"
      />
    </SvgIcon>
  );
}

export default CircleClockFillIcon;
